export default __webpack_public_path__ + "static/cruiselines-royal-ship-2-1aa0e7e2f935135dfc53e717e039d156.jpg";